import React from 'react'
import './button.css'

const AsyncButton = (props) => {
    return (
        <button type={props.type} className="button-element" style={props.isFullWidth ? {width: "100%", backgroundColor: `${props.bgcolor}`} : {backgroundColor: `${props.bgcolor}`}} onClick={props.onClick}>
            {
                props.loading
                    ?
                    <div className="lds-ring">
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                    </div>
                    :
                    undefined
            }
            <div className='button-text' style={props.isFullWidth ? {width: "100%"} : undefined}>
                {props.buttonIcon}
                {props.buttonText}
            </div>
        </button>
    )
}

export default AsyncButton


// WEBPACK FOOTER //
// ./src/components/AsyncButton.js